import { useState } from 'react';
import { CHECKBOX_STATUS } from 'ui/checkbox';

export const useEvenlyDistribute = () => {
  const [evenlyDistribute, setEvenlyDistribute] = useState(CHECKBOX_STATUS.UNCHECKED);
  const toggleEvenlyDistribute = () =>
    setEvenlyDistribute((state) =>
      state === CHECKBOX_STATUS.CHECKED ? CHECKBOX_STATUS.UNCHECKED : CHECKBOX_STATUS.CHECKED,
    );
  return [evenlyDistribute, toggleEvenlyDistribute];
};
